import React, { useEffect, useState, useRef, lazy } from 'react';
import { TestimonialCard } from './TestimonialCard';
import { CTAButton } from './CTAButton';
import { StickyCTA } from './StickyCTA';
import { EyeIcon, CheckCircle, AlertCircle, ImageIcon } from 'lucide-react';
export const Advertorial = () => {
  const [isScrolledPastFirstTwoSections, setIsScrolledPastFirstTwoSections] = useState(false);
  const [isAtTopSection, setIsAtTopSection] = useState(true);
  const [userCity, setUserCity] = useState('New York');
  const firstTwoSectionsRef = useRef(null);
  // Fetch user location data
  useEffect(() => {
    const fetchUserLocation = async () => {
      try {
        const response = await fetch('https://ipinfo.io/json');
        if (response.ok) {
          const data = await response.json();
          if (data.city && data.city.trim() !== '') {
            setUserCity(data.city);
            console.log(`User location detected: ${data.city}`);
          }
        }
      } catch (error) {
        console.error('Error fetching location data:', error);
      }
    };
    fetchUserLocation();
  }, []);
  useEffect(() => {
    // Set initial states
    setIsScrolledPastFirstTwoSections(false);
    setIsAtTopSection(true);
    const scrollOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -90% 0px'
    };
    const topSectionOptions = {
      threshold: 0.3,
      rootMargin: '-100px 0px 0px 0px'
    };
    const scrollObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          setIsScrolledPastFirstTwoSections(true);
        } else {
          setIsScrolledPastFirstTwoSections(false);
        }
      });
    }, scrollOptions);
    const topSectionObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsAtTopSection(true);
        } else {
          setIsAtTopSection(false);
        }
      });
    }, topSectionOptions);
    setTimeout(() => {
      if (firstTwoSectionsRef.current) {
        scrollObserver.observe(firstTwoSectionsRef.current);
        topSectionObserver.observe(firstTwoSectionsRef.current);
      }
    }, 100);
    return () => {
      if (firstTwoSectionsRef.current) {
        scrollObserver.unobserve(firstTwoSectionsRef.current);
        topSectionObserver.unobserve(firstTwoSectionsRef.current);
      }
    };
  }, []);
  useEffect(() => {
    console.log('Scrolled past first two sections:', isScrolledPastFirstTwoSections, 'At top section:', isAtTopSection);
  }, [isScrolledPastFirstTwoSections, isAtTopSection]);
  return <div className="w-full bg-white" data-id="element-7">
      {/* Top Header Bar */}
      <div className="w-full bg-gray-900 text-white" data-id="element-8">
        <div className="container mx-auto px-4 py-2 flex justify-between items-center" data-id="element-9">
          <div className="flex items-center" data-id="element-10">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mr-2" data-id="element-11">
              <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="white" data-id="element-12" />
            </svg>
            <span className="font-semibold tracking-wider" data-id="element-13">WOMEN'S HEALTH</span>
          </div>
          <div className="flex items-center" data-id="element-14">
            <div className="w-5 h-5 mr-2 rounded-full overflow-hidden" data-id="element-15">
              <svg viewBox="0 0 512 512" className="w-full h-full" data-id="element-16">
                <path fill="#f0f0f0" d="M0 85.331h512v341.337H0z" data-id="element-17" />
                <path fill="#d80027" d="M0 85.331h512v42.663H0zm0 85.337h512v42.663H0zm0 85.337h512v42.663H0zm0 85.337h512v42.663H0z" data-id="element-18" />
                <path fill="#2e52b2" d="M0 85.331h256v183.797H0z" data-id="element-19" />
                <path fill="#f0f0f0" d="M99.822 160.624L95.699 173.308H82.363L93.113 181.143L89.021 193.826L99.822 186.034L110.624 193.826L106.532 181.143L117.306 173.308H103.97z" data-id="element-20" />
                <path fill="#f0f0f0" d="M103.622 219.081l-3.284 10.134h-10.638l8.609 6.333-3.284 10.134 8.598-6.348 8.598 6.348-3.284-10.134 8.609-6.333h-10.638zM167.737 160.624l-4.123 12.684h-13.336l10.75 7.835-4.092 12.683 10.801-7.792 10.802 7.792-4.092-12.683 10.774-7.835h-13.336zM167.737 219.081l-3.284 10.134h-10.638l8.609 6.333-3.284 10.134 8.598-6.348 8.598 6.348-3.284-10.134 8.609-6.333h-10.638zM31.908 160.624l-4.123 12.684H14.449l10.75 7.835-4.092 12.683 10.801-7.792 10.802 7.792-4.092-12.683 10.774-7.835H36.031zM31.908 219.081l-3.284 10.134H17.986l8.609 6.333-3.284 10.134 8.598-6.348 8.598 6.348-3.284-10.134 8.609-6.333H35.192z" data-id="element-21" />
              </svg>
            </div>
            <span className="text-sm" data-id="element-22">Trending in the US</span>
          </div>
        </div>
      </div>

      {/* Header */}
      <header className="w-full border-b border-gray-200" data-id="element-23">
        <div className="container mx-auto px-4 py-3" data-id="element-24">
          <p className="text-xs font-semibold text-gray-500 tracking-wider" data-id="element-25">
            WOMEN'S HEALTH | Advertorial
          </p>
        </div>
      </header>

      {/* Notification Banner */}
      <div className="w-full bg-amber-50 border border-amber-200" data-id="element-26">
        <div className="container mx-auto px-4 py-3 flex items-center justify-center text-center" data-id="element-27">
          <AlertCircle className="text-red-500 mr-2 flex-shrink-0" size={20} data-id="element-28" />
          <p className="font-bold text-sm sm:text-base" data-id="element-29">
            UPDATE: Elivara Compression Leggings Are Selling Out FAST! Grab
            Yours NOW to get up to 40% OFF + Fast FREE Shipping Across the US
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4" data-id="element-30">
        <div className="flex flex-col lg:flex-row lg:justify-center" data-id="element-31">
          {/* Main Content */}
          <main className="w-full max-w-3xl mx-auto" data-id="element-32">
            <div className="py-6 px-0 md:px-4" data-id="element-33">
              {/* Headline */}
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 mb-4" data-id="element-34">
                {userCity} Lipedema Specialists Reveal: What to Do After Your
                Lipedema Diagnosis (The First Thing Thousands of Women Tried
                That Actually Worked)
              </h1>

              {/* Subheadline */}
              <p className="text-lg md:text-xl text-gray-600 mb-6" data-id="element-35">
                Just diagnosed and overwhelmed? Here's the simple first step
                that's helping newly diagnosed women find relief without
                complicated treatments or expensive therapy sessions.
              </p>

              {/* Author and Date */}
              <div className="flex items-center justify-between border-b border-gray-200 pb-4 mb-6" data-id="element-36">
                <div className="flex items-center" data-id="element-37">
                  <p className="text-sm text-gray-700" data-id="element-38">
                    By Jennifer Martinez, Women's Health | April 29, 2025
                  </p>
                </div>
                <div className="flex items-center text-sm text-gray-500" data-id="element-39">
                  <EyeIcon size={16} className="mr-1" data-id="element-40" />
                  <span data-id="element-41">312,847</span>
                </div>
              </div>

              {/* Featured Image */}
              <div className="mb-8 rounded-lg overflow-hidden" data-id="element-42">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hb7663489Vj6W5fHFmd7JR/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_11_41_21_%CF%80.%CE%BC..png" alt="Image of a woman looking at her lipedema diagnosis paperwork, showing a mix of relief and uncertainty about what to do next" className="w-full h-auto" data-id="element-43" />
              </div>

              {/* Opening Section */}
              <div className="mb-10" data-id="element-44">
                <p className="mb-4" data-id="element-45">You finally have a diagnosis.</p>
                <p className="mb-4" data-id="element-46">
                  After years of being told to "just lose weight." After
                  countless frustrating doctor visits. After thinking something
                  was wrong with you.
                </p>
                <p className="mb-4" data-id="element-47">You finally have an answer: lipedema.</p>
                <p className="mb-4" data-id="element-48">
                  And now you're asking yourself, "What do I do now?"
                </p>
                <p className="mb-4" data-id="element-49">
                  If you're feeling overwhelmed, confused, or unsure where to
                  start—you're not alone. Thousands of newly diagnosed women
                  have felt exactly the same way.
                </p>
                <p className="mb-4 font-semibold" data-id="element-50">
                  But here's the good news: there's a simple first step that's
                  helping newly diagnosed women find relief. Without jumping
                  into complicated treatment plans or expensive therapy
                  sessions.
                </p>
              </div>

              {/* The Diagnosis Relief Section */}
              <div className="mb-10" ref={firstTwoSectionsRef} data-id="element-51">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-52">
                  The Diagnosis Relief (And Then the Overwhelm)
                </h2>

                <p className="mb-4" data-id="element-53">
                  Getting a lipedema diagnosis can feel like a relief and a
                  burden at the same time.
                </p>
                <p className="mb-4" data-id="element-54">
                  On one hand, you finally have an answer. You finally know it
                  wasn't your fault. You finally understand why diet and
                  exercise didn't work on your legs.
                </p>
                <p className="mb-4" data-id="element-55">
                  On the other hand, you're suddenly facing questions:
                </p>

                <div className="bg-gray-50 p-4 rounded-md mb-6 space-y-2" data-id="element-56">
                  <p className="italic" data-id="element-57">What do I do about it?</p>
                  <p className="italic" data-id="element-58">What treatments work?</p>
                  <p className="italic" data-id="element-59">Where do I even start?</p>
                  <p className="italic" data-id="element-60">How much will this cost?</p>
                  <p className="italic" data-id="element-61">Will I need surgery?</p>
                  <p className="italic" data-id="element-62">Do I have to see specialists?</p>
                </div>

                <p className="mb-4" data-id="element-63">
                  The amount of information can be overwhelming.
                </p>
                <p className="mb-4" data-id="element-64">
                  "We see newly diagnosed women come into our clinic feeling
                  lost," says Dr. Rachel Chen, a leading drainage specialist.
                  "They've just learned they have a chronic condition. They're
                  reading about complicated treatments, expensive therapy
                  sessions, and surgical options. They don't know where to
                  start."
                </p>
                <p className="mb-4" data-id="element-65">
                  "And that overwhelm can actually prevent them from taking any
                  action at all," Dr. Chen explains.
                </p>
                <p className="mb-4 font-semibold" data-id="element-66">
                  But there's a better way to approach this.
                </p>
              </div>

              {/* The Mistake Section */}
              <div className="mb-10" data-id="element-67">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-68">
                  The Mistake Most Newly Diagnosed Women Make
                </h2>

                <p className="mb-4" data-id="element-69">
                  Here's what happens to many women right after diagnosis:
                </p>
                <p className="mb-4" data-id="element-70">
                  They start researching everything. They read about manual
                  drainage therapy. They learn about decongestive therapy. They
                  look into surgical options. They get quotes for expensive
                  specialist appointments.
                </p>
                <p className="mb-4" data-id="element-71">
                  And then they feel paralyzed. Because it all seems so
                  complicated. So expensive. So overwhelming.
                </p>
                <p className="mb-4" data-id="element-72">
                  Some women spend months researching without actually doing
                  anything to help their symptoms. Others jump into expensive
                  treatments without starting with simpler solutions first.
                </p>
                <p className="mb-4" data-id="element-73">
                  "The biggest mistake I see is newly diagnosed women thinking
                  they need to do everything at once," says Dr. Chen. "They feel
                  pressure to immediately start the most intensive treatments.
                  But that's not necessary for everyone, especially in the
                  beginning."
                </p>
              </div>

              {/* What Women Did First Section */}
              <div className="mb-10" data-id="element-74">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-75">
                  What Thousands of Newly Diagnosed Women Did First
                </h2>

                <p className="mb-4" data-id="element-76">
                  In lipedema support groups and online communities, newly
                  diagnosed women started sharing a different approach.
                </p>
                <p className="mb-4" data-id="element-77">
                  Instead of jumping into complicated treatments right away,
                  they started with one simple, at-home solution first.
                </p>
                <p className="mb-4" data-id="element-78">Something that didn't require:</p>

                <ul className="list-disc pl-6 mb-6 space-y-2" data-id="element-79">
                  <li data-id="element-80">Expensive specialist appointments</li>
                  <li data-id="element-81">Complicated therapy schedules</li>
                  <li data-id="element-82">Major lifestyle changes</li>
                  <li data-id="element-83">Surgical procedures</li>
                </ul>

                <p className="mb-4" data-id="element-84">
                  They wanted something they could start immediately. Something
                  manageable. Something that would help them take control
                  without feeling overwhelmed.
                </p>
                <p className="mb-4" data-id="element-85">
                  And what they found was compression technology made for
                  lipedema.
                </p>
                <p className="mb-4" data-id="element-86">
                  But not the old, uncomfortable medical stockings their doctors
                  recommended. Something completely different.
                </p>
              </div>

              {/* The Simple First Step Section */}
              <div className="mb-10" data-id="element-87">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-88">
                  The Simple First Step That's Working
                </h2>

                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-89">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qXr4YxNDa3ZLDxwoFvkcy4/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_11_41_34_%CF%80.%CE%BC..png" alt="Image of Elivara compression leggings showing the stylish design with FlowMapping™ technology zones" className="w-full h-auto" data-id="element-90" />
                </div>

                <p className="mb-4" data-id="element-91">
                  The solution newly diagnosed women found is called
                  FlowMapping™ Compression—developed by a company called
                  Elivara.
                </p>
                <p className="mb-4" data-id="element-92">
                  It's the first compression made from the ground up for
                  lipedema. Not adapted from other conditions. Not generic
                  medical stockings. Built for women with lipedema.
                </p>
                <p className="mb-4 font-semibold" data-id="element-93">
                  Here's why this works as a simple first step:
                </p>

                <div className="bg-green-50 p-6 rounded-md mb-6" data-id="element-94">
                  <p className="font-semibold mb-2 text-lg" data-id="element-95">
                    It's Easy to Start
                  </p>
                  <p className="mb-4" data-id="element-96">
                    You don't need appointments. You don't need a specialist's
                    approval. You don't need complicated instructions.
                  </p>
                  <p className="mb-4" data-id="element-97">
                    You put them on like regular leggings. And they work
                    throughout your day.
                  </p>
                </div>

                <div className="bg-green-50 p-6 rounded-md mb-6" data-id="element-98">
                  <p className="font-semibold mb-2 text-lg" data-id="element-99">
                    It Addresses the Core Problem
                  </p>
                  <p className="mb-4" data-id="element-100">
                    Lipedema involves poor drainage. Fluid builds up in your
                    legs. Your drainage system doesn't work properly.
                  </p>
                  <p className="mb-4" data-id="element-101">
                    FlowMapping™ uses different pressure areas that follow your
                    body's natural drainage pathways. The pressure is strongest
                    at your ankles (where fluid builds up most). And it gets
                    lighter as it moves up your leg.
                  </p>
                  <p className="mb-4" data-id="element-102">
                    This gentle pressure slope helps trapped fluid move upward
                    and drain properly. Naturally supporting what your body
                    struggles to do on its own.
                  </p>
                </div>

                <div className="bg-green-50 p-6 rounded-md mb-6" data-id="element-103">
                  <p className="font-semibold mb-2 text-lg" data-id="element-104">It Works All Day</p>
                  <p className="mb-4" data-id="element-105">
                    Unlike therapy sessions that last an hour and then you're on
                    your own, FlowMapping™ provides continuous support
                    throughout your entire day.
                  </p>
                  <p className="mb-4" data-id="element-106">
                    You're not dependent on appointment schedules or someone
                    else's availability. You have control over your own
                    management.
                  </p>
                </div>

                <div className="bg-green-50 p-6 rounded-md mb-6" data-id="element-107">
                  <p className="font-semibold mb-2 text-lg" data-id="element-108">
                    It's Designed for Lipedema
                  </p>
                  <p className="mb-4" data-id="element-109">
                    Every aspect of FlowMapping™ is built around lipedema:
                  </p>
                  <ul className="list-disc pl-6 space-y-2" data-id="element-110">
                    <li data-id="element-111">
                      Pressure areas matched to where lipedema fat builds up
                    </li>
                    <li data-id="element-112">
                      Gentle compression in tender spots common with lipedema
                    </li>
                    <li data-id="element-113">Extra support where you need it most</li>
                    <li data-id="element-114">Comfortable enough to wear all day</li>
                    <li data-id="element-115">Looks like regular leggings, not medical devices</li>
                  </ul>
                </div>

                <p className="mb-4" data-id="element-116">
                  "This is the perfect starting point for newly diagnosed
                  women," says Dr. Chen, who now recommends Elivara to her newly
                  diagnosed patients. "It gives them a way to take action
                  immediately. To start finding relief. Without the overwhelm of
                  complicated treatment plans."
                </p>
              </div>

              {/* Visual Explanation of FlowMapping™ Technology */}
              <div className="mb-10" data-id="element-117">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-118">
                  See the FlowMapping™ Difference
                </h2>
                <div className="mb-6 rounded-lg overflow-hidden bg-blue-50 p-4" data-id="element-119">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4ge5gzuHf48wNS9HaJaGCz/gempages_541671622348637232-7a3a123c-f1c8-4b25-b1a4-f051e570e74b.webp" alt="Animation showing the difference between painful lipedema fluid buildup (left, red areas) and the FlowMapping™ technology directing fluid flow (right, green chevrons)" className="w-full h-auto mx-auto" data-id="element-120" />
                  <div className="flex justify-between mt-4 text-sm md:text-base" data-id="element-121">
                    <div className="text-center w-1/2 border-r border-blue-200 pr-2" data-id="element-122">
                      <p className="font-bold text-red-500 mb-1" data-id="element-123">
                        WITHOUT SUPPORT
                      </p>
                      <p className="text-gray-700" data-id="element-124">
                        Painful fluid buildup and inflammation
                      </p>
                    </div>
                    <div className="text-center w-1/2 pl-2" data-id="element-125">
                      <p className="font-bold text-green-500 mb-1" data-id="element-126">
                        WITH FLOWMAPPING™
                      </p>
                      <p className="text-gray-700" data-id="element-127">
                        Guided fluid drainage along natural pathways
                      </p>
                    </div>
                  </div>
                </div>
                <p className="mb-4" data-id="element-128">
                  This visual perfectly captures what makes FlowMapping™
                  technology so revolutionary. On the left, you can see what
                  happens in lipedema-affected legs: fluid builds up (shown in
                  red), creating painful inflammation and swelling that doesn't
                  respond to diet or exercise.
                </p>
                <p className="mb-4" data-id="element-129">
                  On the right, you see how Elivara's patented FlowMapping™
                  technology works. The strategically placed compression zones
                  (shown as green chevrons) create directional pressure that
                  guides trapped fluid along your natural lymphatic pathways.
                  This helps your body drain the fluid properly, reducing
                  swelling, pain, and that heavy feeling that comes with
                  lipedema.
                </p>
              </div>

              {/* What Women Are Experiencing Section */}
              <div className="mb-10" data-id="element-130">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-131">
                  What Newly Diagnosed Women Are Experiencing
                </h2>

                <p className="mb-6" data-id="element-132">
                  Women who started with FlowMapping™ compression right after
                  diagnosis report different results than those who jumped into
                  complicated treatments immediately.
                </p>

                <div className="space-y-6 mb-6" data-id="element-133">
                  <TestimonialCard quote="I got diagnosed 2 months ago and felt completely lost. Elivara gave me a simple first step that actually helped." author="Sarah M." age="41" location="Chicago, IL" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/eb9DbMXxnEv4xRdj6M31AN/Beth_-_living_with_lipedema.webp" data-id="element-134" />

                  <TestimonialCard quote="When I got my diagnosis, I spent weeks researching treatments. Manual drainage therapy. Decongestive therapy. All these complicated, expensive options. I felt paralyzed. Then I found Elivara in a support group. It was the first thing that felt manageable. I could start immediately. And it helped. My legs feel lighter. The swelling is less. And I didn't have to figure out complicated therapy schedules or spend thousands on appointments." author="Jessica T." age="38" location="Portland, OR" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/3y7To7DiABw2UivqWYkvYv/images_%2842%29.jpg" data-id="element-135" />

                  <TestimonialCard quote="Finally, something I could do right away without waiting for specialist appointments." author="Nicole R." age="39" location="Queens, NY" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/1ZzQbxP1337U3TnJrDfMSW/istockphoto-1290775513-612x612.jpg" data-id="element-136" />

                  <TestimonialCard quote="After my diagnosis, my doctor wanted me to see a specialist for manual drainage therapy. But the wait was 3 months. I felt helpless. I wanted to do something NOW. I found Elivara and started wearing them immediately. By the time my specialist appointment came around, my legs already felt so much better. The specialist was impressed with the improvement." author="Michelle K." age="44" location="Long Island, NY" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/jA5TbK1HAopveddK7FXfLL/mockup-pretty-curvy-latin-woman-600nw-2460705183.webp" data-id="element-137" />

                  <TestimonialCard quote="I wish I'd known about this the day I got diagnosed instead of spending months feeling overwhelmed." author="Rebecca L." age="44" location="Nashville, TN" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/8hW674k71ojpsCMkVCgv6R/Screenshot_2025-09-30_at_00.02.40.png" data-id="element-138" />

                  <TestimonialCard quote="I got my diagnosis and immediately fell into research overwhelm. I read about every treatment option. I got confused. I did nothing for months because I couldn't decide what to try first. When I finally found Elivara, I realized this is what I should have started with. Simple. Manageable. Helpful. Now I feel like I have some control over my condition." author="Amanda K." age="38" location="Austin, TX" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/hq1HCFwLGMXQeBfL6EFNpY/istockphoto-1180524344-612x612.jpg" data-id="element-139" />

                  <TestimonialCard quote="As a newly diagnosed woman, this was exactly what I needed—simple relief without complexity." author="Linda M." age="51" location="Chicago, IL" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/nJ43KvrRnAa3kWNkkTfCWz/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_12_12_37_%CF%80.%CE%BC..png" data-id="element-140" />
                </div>
              </div>

              {/* Why This Works as a First Step Section */}
              <div className="mb-10" data-id="element-141">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-142">
                  Why This Works as a First Step
                </h2>

                <p className="mb-4" data-id="element-143">
                  Let's be clear about what FlowMapping™ compression is and
                  isn't.
                </p>
                <p className="mb-4" data-id="element-144">
                  It's not a cure. Lipedema is a chronic condition. There's no
                  cure yet.
                </p>
                <p className="mb-4" data-id="element-145">
                  It's not the only thing you might ever need. Some women will
                  benefit from additional treatments like therapy or surgery
                  down the line.
                </p>
                <p className="mb-4 font-semibold" data-id="element-146">
                  But it is an excellent first step for newly diagnosed women
                  because:
                </p>

                <div className="space-y-4 mb-6" data-id="element-147">
                  <div className="bg-blue-50 p-4 rounded-md" data-id="element-148">
                    <p className="font-semibold mb-2" data-id="element-149">
                      It Gives You Immediate Action
                    </p>
                    <p data-id="element-150">
                      Instead of spending weeks or months researching and
                      feeling paralyzed, you can start doing something helpful
                      right away.
                    </p>
                  </div>

                  <div className="bg-blue-50 p-4 rounded-md" data-id="element-151">
                    <p className="font-semibold mb-2" data-id="element-152">It's Manageable</p>
                    <p data-id="element-153">
                      You don't need to reorganize your life. You don't need
                      complicated schedules. You just wear them like regular
                      leggings.
                    </p>
                  </div>

                  <div className="bg-blue-50 p-4 rounded-md" data-id="element-154">
                    <p className="font-semibold mb-2" data-id="element-155">
                      It Provides Real Relief
                    </p>
                    <p data-id="element-156">
                      This isn't a placebo. The pressure zones are engineered to
                      support drainage. Women report feeling lighter legs, less
                      swelling, and less pain.
                    </p>
                  </div>

                  <div className="bg-blue-50 p-4 rounded-md" data-id="element-157">
                    <p className="font-semibold mb-2" data-id="element-158">It Builds Confidence</p>
                    <p data-id="element-159">
                      When you start seeing improvement, you feel more confident
                      about managing your condition. You feel less helpless.
                    </p>
                  </div>

                  <div className="bg-blue-50 p-4 rounded-md" data-id="element-160">
                    <p className="font-semibold mb-2" data-id="element-161">It's a Foundation</p>
                    <p data-id="element-162">
                      Even if you decide to pursue additional treatments later,
                      FlowMapping™ compression can continue supporting your
                      drainage system alongside other therapies.
                    </p>
                  </div>
                </div>

                <p className="mb-4" data-id="element-163">
                  "I always tell newly diagnosed women: start simple," says Dr.
                  Chen. "You don't need to tackle everything at once. Start with
                  something that helps. Build from there. FlowMapping™ gives
                  them that foundation."
                </p>
              </div>

              {/* This Is Your Chance Section */}
              <div className="mb-10 bg-gray-100 p-6 rounded-lg" data-id="element-164">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-165">
                  This Is Your Chance to Take That First Step
                </h2>

                <div className="mb-6 bg-white rounded-lg overflow-hidden" data-id="element-166">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/23Hx8bzAVQ7dcDK8zTNUdC/Trusted_by_Women_Across_the_USA.png" alt="Elivara Lipedema Leggings with premium packaging, 30-day money back guarantee, and free shipping" className="w-full h-auto" data-id="element-167" />
                </div>

                <p className="mb-4" data-id="element-168">
                  Here's something important to know. Elivara uses specialized
                  FlowMapping™ technology. It's made for lipedema. Because of
                  this, they can only produce limited quantities at a time.
                </p>
                <p className="mb-4" data-id="element-169">
                  Right now, they're offering newly diagnosed women an exclusive
                  opportunity to save 40% off their order.
                </p>
                <p className="mb-4" data-id="element-170">
                  This isn't a permanent discount. It's made to help women who
                  just got diagnosed. To give them an accessible first step
                  without the premium price tag that usually comes with
                  specialized medical items.
                </p>
                <p className="mb-4 font-semibold" data-id="element-171">
                  But here's the reality. Elivara sells out regularly.
                </p>
                <p className="mb-4" data-id="element-172">
                  When newly diagnosed women discover something that actually
                  helps without overwhelming them, word spreads fast. Through
                  support groups and online communities. Popular sizes often
                  disappear within days. And then you have to wait weeks for the
                  next production run.
                </p>
                <p className="mb-4" data-id="element-173">
                  If you've just been diagnosed and you're looking for a simple
                  first step, this is it.
                </p>
              </div>

              {/* Final Section */}
              <div className="mb-10" data-id="element-174">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-175">
                  You Don't Have to Figure Everything Out Right Now
                </h2>

                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-176">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fcFTP9s5La88PDr9GNhj1H/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_11_41_56_%CF%80.%CE%BC..png" alt="Woman confidently walking, feeling relief after starting her lipedema management journey with Elivara" className="w-full h-auto" data-id="element-177" />
                </div>

                <p className="mb-4" data-id="element-178">
                  If you just got diagnosed with lipedema, I want you to hear
                  this:
                </p>
                <p className="mb-4 font-semibold" data-id="element-179">
                  You don't have to have all the answers today.
                </p>
                <p className="mb-4" data-id="element-180">
                  You don't have to research every treatment option immediately.
                  You don't have to decide on your entire management plan this
                  week. You don't have to become an expert overnight.
                </p>
                <p className="mb-4" data-id="element-181">
                  What you need is a simple first step. Something that helps.
                  Something that gives you a sense of control.
                </p>
                <p className="mb-4" data-id="element-182">
                  Compression made for lipedema is that first step for thousands
                  of newly diagnosed women.
                </p>
                <p className="mb-4" data-id="element-183">
                  It's not overwhelming. It's not complicated. It's not
                  expensive therapy sessions or surgical consultations.
                </p>
                <p className="mb-4" data-id="element-184">
                  It's putting on a pair of leggings in the morning that help
                  your legs feel better throughout the day.
                </p>
                <p className="mb-4" data-id="element-185">
                  Imagine starting to see improvement in your first month after
                  diagnosis. Instead of spending that month paralyzed by
                  overwhelm and research.
                </p>
                <p className="mb-4" data-id="element-186">
                  Imagine your legs feeling lighter. Less swollen. Less painful.
                  Just from one simple, manageable change.
                </p>
                <p className="mb-4" data-id="element-187">
                  Imagine feeling like you have some control over this
                  condition. Instead of feeling helpless and lost.
                </p>
                <p className="mb-4" data-id="element-188">
                  Imagine telling other newly diagnosed women in support groups,
                  "This is what I started with. It helped. You can do this."
                </p>
                <p className="mb-4 font-semibold" data-id="element-189">
                  That's what FlowMapping™ can give you.
                </p>
                <p className="mb-4" data-id="element-190">
                  You just got a diagnosis. You have a name for what you've been
                  dealing with. You know it's not your fault.
                </p>
                <p className="mb-4 font-semibold" data-id="element-191">
                  Now take the first step toward relief.
                </p>
                <p className="mb-6" data-id="element-192">
                  Don't spend months feeling overwhelmed and doing nothing.
                  Don't wait for specialist appointments that are months away.
                  Don't let analysis paralysis stop you from finding relief.
                </p>
                <p className="mb-4" data-id="element-193">
                  Start simple. Start with what's working for thousands of newly
                  diagnosed women. Start today.
                </p>
                <p className="mb-4" data-id="element-194">
                  You deserve to feel relief. And you deserve to feel confident
                  that you're managing your condition.
                </p>
                <p className="mb-4 font-semibold" data-id="element-195">This is your first step.</p>
              </div>
            </div>
          </main>

          {/* Right-side CTA - Always visible on desktop */}
          <aside className="hidden lg:block lg:w-80 lg:ml-8 lg:flex-shrink-0 mt-6" data-id="element-196">
            <div className="sticky top-6" data-id="element-197">
              <StickyCTA showNewImage={true} data-id="element-198" />
            </div>
          </aside>
        </div>
      </div>

      {/* Sticky CTA - Always visible at the bottom */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-3 z-50" data-id="element-199">
        <a href="https://tryelivara.com/pages/elivara-landing-page" className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-4 rounded-lg shadow-md transition-all w-full uppercase tracking-wider text-center block" data-id="element-200">
          DISCOVER ELIVARA & SAVE 40% TODAY →
        </a>
      </div>

      {/* Special Offer Banner */}
      <div className="w-full bg-red-50 border-y border-red-200" data-id="element-201">
        <div className="container mx-auto px-4 py-6" data-id="element-202">
          <div className="flex flex-col sm:flex-row items-center justify-center text-center gap-4" data-id="element-203">
            <div className="flex items-center" data-id="element-204">
              <AlertCircle className="text-red-500 mr-2 flex-shrink-0" size={24} data-id="element-205" />
              <p className="font-bold text-lg" data-id="element-206">SPECIAL OFFER:</p>
            </div>
            <p className="font-bold text-red-700 text-lg px-4" data-id="element-207">
              Get Elivara Compression Leggings at 40% OFF + FREE Shipping for a
              Limited Time!
            </p>
            <a href="https://tryelivara.com/pages/elivara-landing-page" className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-lg text-base whitespace-nowrap inline-block" data-id="element-208">
              CLAIM OFFER
            </a>
          </div>
        </div>
      </div>

      {/* Disclaimer */}
      <footer className="w-full bg-gray-100" data-id="element-209">
        <div className="container mx-auto px-4 py-6 max-w-4xl" data-id="element-210">
          <div className="text-xs text-gray-500 pt-6 mb-8" data-id="element-211">
            <p className="mb-2" data-id="element-212">
              This is an advertisement and not an actual news article, blog, or
              consumer protection update. Individual results may vary.
            </p>
            <div className="flex flex-wrap space-x-2 mb-2" data-id="element-213">
              <span data-id="element-214">About Us</span>
              <span data-id="element-215">|</span>
              <span data-id="element-216">Terms of Use</span>
              <span data-id="element-217">|</span>
              <span data-id="element-218">Privacy Policy</span>
            </div>
            <p className="mb-2" data-id="element-219">
              Trademarks utilized on our website belong to their respective
              owners and no implied or expressed endorsement of our website or
              services is intended. Through in-depth research and experienced
              editors we provide feedback about products and services. We are
              independently owned, and opinions expressed here are our own. This
              website is an independent professional comparison and review site
              supported by referral fees from the sites and products featured.
            </p>
            <p data-id="element-220">©2025 Women's Health Insights. All Rights Reserved.</p>
          </div>
        </div>
      </footer>
    </div>;
};